import React from 'react';
import { Text } from '../typography/Text';

export function Address() {
  return (
    <address className="not-italic">
      <div className="space-y-1">
        <Text className="text-gray-600 text-sm font-medium">
          OmegaWalls OÜ
        </Text>
        <Text className="text-gray-600 text-sm">
          Reg. №: 16473723
        </Text>
        <div className="space-y-0.5">
          <Text className="text-gray-600 text-sm">
            Vesivärava tn 50-201,
          </Text>
          <Text className="text-gray-600 text-sm">
            Kesklinna linnaosa,
          </Text>
          <Text className="text-gray-600 text-sm">
            Tallinn, Harju maakond 10152
          </Text>
          <Text className="text-gray-600 text-sm">
            Estonia
          </Text>
        </div>
      </div>
    </address>
  );
}